import React from 'react';
import { FieldArray } from 'react-final-form-arrays';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import TextField from '@material-ui/core/TextField';
import { Form } from 'react-final-form';
import arrayMutators from 'final-form-arrays';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import CloseIcon from '@material-ui/icons/Close';
import InputMask from 'react-input-mask';

const AdditionalPhoneNumbers = ({
  additionalContactList,
  setAdditionalContactList,
  handleAddAdditionalContact,
  setIsPhoneNumberListValid,
}) => {
  const handleChange = (value, index) => {
    const contactListCopy = [...additionalContactList];
    if (!isNaN(value)) {
      contactListCopy[index].phoneNumber = value;
    }
    setAdditionalContactList(contactListCopy);
  };

  const handleRemoveContact = (index) => {
    const contactListCopy = [...additionalContactList];
    contactListCopy.splice(index, 1);
    handleBlur(contactListCopy); // Check for errors
    setAdditionalContactList(contactListCopy);
  };

  const handleBlur = (contactList = null) => {
    const list = contactList || additionalContactList;
    const hasError = list.some((item) => item.phoneNumber?.length !== 10);
    setIsPhoneNumberListValid(!hasError);
  };

  return (
    <Box>
      <Form
        onSubmit={(e) => console.log(e)}
        mutators={{
          // potentially other mutators could be merged here
          ...arrayMutators,
        }}
        render={({ handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <FieldArray name="contacts">
              {({ fields }) => (
                <>
                  {additionalContactList.map((name, index) => (
                    <div
                      key={name}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'flex-start',
                        marginBottom: 10,
                      }}
                    >
                      <div>
                        <InputMask
                          mask="(999) 999-9999"
                          placeholder="Phone Number"
                          value={additionalContactList[index]?.phoneNumber}
                          onChange={(e) =>
                            handleChange(
                              e.target.value.replace(/[^0-9]/g, ''),
                              index,
                            )
                          }
                          onBlur={() => handleBlur(null)}
                        >
                          {(inputProps) => <TextField {...inputProps} />}
                        </InputMask>
                      </div>
                      <IconButton
                        onClick={() => {
                          fields.remove(index);
                          return handleRemoveContact(index);
                        }}
                        style={{
                          color: '#9E9E9E',
                          marginRight: 10,
                        }}
                      >
                        <CloseIcon />
                      </IconButton>
                    </div>
                  ))}

                  <Button
                    variant="text"
                    disabled={fields.length === 10}
                    startIcon={<AddCircleIcon />}
                    onClick={() => {
                      fields.push({
                        phoneNumber: '',
                      });
                      return handleAddAdditionalContact();
                    }}
                    style={{ marginBottom: 10 }}
                  >
                    Add Mobile Phone Number
                  </Button>
                </>
              )}
            </FieldArray>
          </form>
        )}
      />
    </Box>
  );
};

export default AdditionalPhoneNumbers;
